import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(() => ({
  overlay: {
    top: 0,
    left: 0,
    zIndex: 1,
    position: 'absolute',
    borderTop: '60px solid rgba(0, 0, 0, 0.7)',
    borderBottom: '60px solid rgba(0, 0, 0, 0.7)',
    borderLeft: '40px solid rgba(0, 0, 0, 0.7)',
    borderRight: '40px solid rgba(0, 0, 0, 0.7)',
    width: '100%',
    height: '100%',
    MozBoxSizing: 'border-box',
    WebkitBoxSizing: 'border-box',
    boxSizing: 'border-box',
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
  },
  qrReaderContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.9)',
    MozBoxSizing: 'border-box',
    WebkitBoxSizing: 'border-box',
    boxSizing: 'border-box',
  },
  resultText: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    bottom: 0,
    fontSize: 16,
    fontWeight: 600,
    color: '#fff',
    zIndex: 999,
  },
  closeButton: {
    position: 'absolute',
    top: 16,
    right: 24,
    zIndex: 999,
    color: '#fff',
  },
}));
